import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import helpers from "../../../assets/js/helper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1E6A99 !important",
    color: theme.palette.common.white,
    outerHeight: "30px !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "& td": {
    borderLeft: "0px",
    borderRight: "0px",
  },
  "& th": {
    padding: "0px !important",
  },
}));

export default function FinancesList(props) {
  const [t] = useTranslation("common");
  return (
    <Box
      sx={{
        width: "100%",
        margin: "10px 20px 10px 10px",
        "& th": {
          padding: "5px 15px !important",
        },
      }}
    >
      <TableContainer>
        <Table sx={{ minWidth: "100%" }} aria-label="customized table">
          <TableHead sx={{ height: "20px !important" }}>
            <TableRow sx={{ height: "20px !important" }}>
              <StyledTableCell align="left" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>#</span>
              </StyledTableCell>
              <StyledTableCell align="left" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>الفني</span>
              </StyledTableCell>
              <StyledTableCell align="left" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>المبلغ</span>
              </StyledTableCell>
              <StyledTableCell align="left" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>التاريخ</span>
              </StyledTableCell>
              <StyledTableCell align="left" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>ملاحظة</span>
              </StyledTableCell>
              {props?.deleteFinance ? (
                <StyledTableCell
                  align="right"
                  sx={{ fontFamily: "Cairo-Bold" }}
                >
                  حذف
                </StyledTableCell>
              ) : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.list?.length > 0 ? (
              props?.list?.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell align="left" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row?.id}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row.technician.name}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row?.amount}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {helpers.formatDate(row?.date)}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row?.note}
                    </Box>
                  </StyledTableCell>
                  {props?.deleteFinance ? (
                    <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                      <RemoveCircleIcon
                        sx={{ color: "#f00", cursor: "pointer" }}
                        onClick={() => props?.deleteFinance(row?.id)}
                      />
                    </StyledTableCell>
                  ) : null}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableCell component="th" scope="row" colSpan={7}>
                <Box
                  sx={{
                    fontFamily: "Cairo-Medium",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  لا يوجد تفاصيل
                </Box>
              </StyledTableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
